import React, { useState, useEffect } from 'react'
import { supabase } from './supabase'

function Budget() {
  const [userEmail, setUserEmail] = useState('local')
  const [transactions, setTransactions] = useState([])
  const [form, setForm] = useState({
    description: '',
    amount: '',
    category: '',
    type: 'expense',
    date: new Date().toISOString().split('T')[0]
  })
  const [editingId, setEditingId] = useState(null)
  const [editForm, setEditForm] = useState({})

  useEffect(() => { getUser() }, [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => { if (userEmail && userEmail !== 'local') fetchTransactions() }, [userEmail])

  async function getUser() {
    try {
      const cookie = document.cookie.split(';').find(c => c.trim().startsWith('CF_Authorization='))
      if (cookie) {
        const token = cookie.trim().replace('CF_Authorization=', '')
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
        if (payload.email) { setUserEmail(payload.email); return }
      }
    } catch {}
    const cached = localStorage.getItem('bf_user_email')
    setUserEmail(cached || 'local')
  }

  async function fetchTransactions() {
    const { data, error } = await supabase
      .from('Transactions')
      .select('*')
      .eq('user_email', userEmail)
      .order('date', { ascending: false })
    if (!error) setTransactions(data)
  }

  async function addTransaction() {
    if (!form.description || !form.amount) return
    const { error } = await supabase
      .from('Transactions')
      .insert([{ ...form, amount: parseFloat(form.amount), user_email: userEmail }])
    if (!error) {
      setForm({ description: '', amount: '', category: '', type: 'expense', date: new Date().toISOString().split('T')[0] })
      fetchTransactions()
    }
  }

  function startEdit(t) {
    setEditingId(t.id)
    setEditForm({
      description: t.description,
      amount: t.amount,
      category: t.category,
      type: t.type,
      date: t.date
    })
  }

  async function saveEdit() {
    if (!editForm.description || !editForm.amount) return
    const { error } = await supabase
      .from('Transactions')
      .update({ ...editForm, amount: parseFloat(editForm.amount) })
      .eq('id', editingId)
    if (!error) {
      setEditingId(null)
      setEditForm({})
      fetchTransactions()
    }
  }

  function cancelEdit() {
    setEditingId(null)
    setEditForm({})
  }

  async function deleteTransaction(id) {
    const { error } = await supabase
      .from('Transactions')
      .delete()
      .eq('id', id)
    if (!error) fetchTransactions()
  }

  const income = transactions.filter(t => t.type === 'income').reduce((sum, t) => sum + t.amount, 0)
  const expenses = transactions.filter(t => t.type === 'expense').reduce((sum, t) => sum + t.amount, 0)
  const balance = income - expenses

  return (
    <div>
      <div className="summary-cards">
        <div className="card green">
          <p>Income</p>
          <h3>${income.toFixed(2)}</h3>
        </div>
        <div className="card red">
          <p>Expenses</p>
          <h3>${expenses.toFixed(2)}</h3>
        </div>
        <div className="card blue">
          <p>Balance</p>
          <h3>${balance.toFixed(2)}</h3>
        </div>
      </div>

      <div className="form-section">
        <h3>Add Transaction</h3>
        <div className="form-row">
          <input placeholder="Description" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
          <input placeholder="Amount" type="number" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} />
          <input placeholder="Category" value={form.category} onChange={e => setForm({...form, category: e.target.value})} />
          <select value={form.type} onChange={e => setForm({...form, type: e.target.value})}>
            <option value="expense">Expense</option>
            <option value="income">Income</option>
          </select>
          <input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} />
          <button onClick={addTransaction}>Add</button>
        </div>
      </div>

      <div className="transactions-list">
        <h3>Transactions</h3>
        {transactions.length === 0 && (
          <p style={{ color: 'var(--text-tertiary)', fontSize: '14px', padding: '16px 0' }}>No transactions yet.</p>
        )}
        {transactions.map(t => (
          <div key={t.id}>
            {editingId === t.id ? (
              <div className="transaction-edit">
                <div className="form-row">
                  <input placeholder="Description" value={editForm.description} onChange={e => setEditForm({...editForm, description: e.target.value})} />
                  <input placeholder="Amount" type="number" value={editForm.amount} onChange={e => setEditForm({...editForm, amount: e.target.value})} />
                  <input placeholder="Category" value={editForm.category} onChange={e => setEditForm({...editForm, category: e.target.value})} />
                  <select value={editForm.type} onChange={e => setEditForm({...editForm, type: e.target.value})}>
                    <option value="expense">Expense</option>
                    <option value="income">Income</option>
                  </select>
                  <input type="date" value={editForm.date} onChange={e => setEditForm({...editForm, date: e.target.value})} />
                  <button onClick={saveEdit}>Save</button>
                  <button onClick={cancelEdit} style={{ background: 'var(--text-tertiary)' }}>Cancel</button>
                </div>
              </div>
            ) : (
              <div className={`transaction-item ${t.type}`}>
                <div>
                  <strong>{t.description}</strong>
                  <span>{t.category}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ textAlign: 'right' }}>
                    <strong>{t.type === 'income' ? '+' : '-'}${t.amount.toFixed(2)}</strong>
                    <span>{t.date}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => startEdit(t)} style={{ padding: '4px 10px', background: 'var(--bg-tertiary)', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: 'var(--text-primary)' }}>Edit</button>
                    <button onClick={() => deleteTransaction(t.id)} style={{ padding: '4px 10px', background: 'var(--bg-tertiary)', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#e94560' }}>Delete</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Budget
